import { NgModule } from '@angular/core';

import {
    RouterModule,
    Routes
} from '@angular/router';

import { AuthModule, AuthGuard } from '../auth.module';

// Components.
import { BaseComponent } from './base';
// Resolvers.
import { UserResolver } from '../inventory.module/user.resolver';
import { SeasonsAccessGrantedResolver } from './seasons.resolver';

const routes: Routes = [{
    path: 'enter-legacy',
    canActivate: [AuthGuard],
    component: BaseComponent,
    resolve: {
        user: UserResolver,
        accessGranted: SeasonsAccessGrantedResolver
    }
}];

@NgModule({
    imports: [
        AuthModule,
        RouterModule.forRoot(routes)
    ],
    exports: [RouterModule],
    providers: [
        // Services.
        // Resolvers.
        UserResolver,
        SeasonsAccessGrantedResolver
    ]
})
export class RoutingModule { }
